import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import SocialLoginDisplayComponent from '../SocialLoginDisplayComponent/SocialLoginDisplayComponent';

class SocialLoginPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            firstName: this.props.firstName,
            currentPage: this.props.currentPage,
            authAccountType: this.props.authAccountType,
            error: '',
            errorTitle: ''
        };
        this.handleError = this.handleError.bind(this);
        this.clearAlert = this.clearAlert.bind(this);
    }

    clearAlert() {
        this.setState({error: '', errorTitle: ''});
    }

    handleError(error) {
        this.setState({error});
    }

    render() {
        let cardContent = (<SocialLoginDisplayComponent
            lingua={this.props.lingua}
            emailAddress={this.props.emailAddress}
            authAccountType={this.props.authAccountType}
            performBulkPageUpdate={this.props.performBulkPageUpdate}
            service={this.props.service}
            handleError={this.handleError}
            onClose={this.props.onClose}
            site={this.props.site}
            setAuthJson={this.props.setAuthJson}
            token ={this.props.token}
            multiUserEnabled ={this.props.multiUserEnabled}
            updatePage={this.props.updatePage}
                           />);

        return (
            <div className="SocialLogInPageDisplayComponent">
                <HeaderSectionComponent header={this.props.lingua.read('lex.header.login')}/>
                <CalloutCardComponent content={cardContent} error={this.state.error} errorTitle={this.state.errorTitle} authAccountType={this.props.authAccountType}
                    performBulkPageUpdate={this.props.performBulkPageUpdate} clearAlert={this.clearAlert} />
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </div>
        );
    }
}

export default SocialLoginPageComponent;
